module.exports = __webpack_public_path__ + "static/media/mus_musculus.female.f9507662.svg";